import * as React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../Contexts/AuthContext";
import { useSelector } from "react-redux";
import type { RootState } from "../Services/Store";

export type ProtectedRouteProps = {
  authenticationPath: string;
  allowedRoles?: string[];
 allowedUserTypes?: string[];
  outlet: React.ReactElement;
  redirectPath?: string;
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  authenticationPath,
  allowedRoles,
  allowedUserTypes,
  outlet,
  redirectPath,
}) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const user = useSelector((state: RootState) => state.auth.user);
  const authLoading = useSelector((state: RootState) => state.auth.loading);
  const authError = useSelector((state: RootState) => state.auth.error);
  const hasToken =
    !!localStorage.getItem("token") || !!sessionStorage.getItem("token");

  // Wait while user bootstrap is in progress
  if (authLoading || ((isAuthenticated || hasToken) && !user && !authError)) {
    return <div>Loading...</div>;
  }
  if ((!isAuthenticated && !hasToken) || ((isAuthenticated || hasToken) && !user && authError)) {
    return <Navigate to={authenticationPath} state={{ from: location }} replace />;
  }
  if (allowedRoles && user && !allowedRoles.includes(user.role_name)) {
    return <Navigate to={redirectPath || "/shop"} replace />;
  }
  if (allowedUserTypes && user) {
    const type = String(user.user_type || "").toUpperCase();
    const allowed = allowedUserTypes.some((t) => t.toUpperCase() === type);
    if (!allowed) {
      return <Navigate to={redirectPath || "/shop"} replace />;
    }
  }
  return outlet;
};

export default ProtectedRoute;
